import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import isLink from './isLink.js'
import isCheck from './isCheck.js'

export default contract({
  isLink: array([
    isLink
  ]),
  isCheck: array([
    isCheck
  ]),
})